import api from '@/services/api/organizations.api'
import pageApi from '@/services/api/pages.api'

export default {
  state: {
    connections: [],
    organization: {},
    uploadPages: []
  },
  mutations: {
    setConnections (state, payload) {
      state.connections = payload
    },
    setOrganization (state, payload) {
      state.organization = payload
    },
    setUploadPages (state, payload) {
      state.uploadPages = payload
    }
  },
  actions: {
    async createOrganizationConnection ({ commit, state }, payload) {
      const { data } = await api.createOrganizationConnection(state.organization.id, payload.code, 'google')
      commit('setConnections', state.connections.concat(data.connection))
    },
    async createOrganizationPage ({ commit, state }, payload) {
      const { data } = await pageApi.createOrganizationPage(payload.title, state.organization.id, payload.connectionId)
      commit('setUploadPages', state.uploadPages.concat(data.page))
    },
    getOrganizationConnections ({ commit, state }) {
      return api.getOrganizationConnections(state.organization.id).then(({ data }) => {
        commit('setConnections', data.connections)
      })
    },
    async getOrganizationUploadPages ({ commit, state }) {
      const { data } = await api.getOrganizationPages(state.organization.id)
      commit('setUploadPages', data.pages)
    }
  },
  getters: {
    getConnections (state) {
      return state.connections
    },
    getOrganization (state) {
      return state.organization
    },
    getUploadPages (state) {
      return state.uploadPages
    }
  }
}
